<ng-container *ngIf="showResults">
  <app-results-visual-aid
    *ngIf="isVisualAidCall; else nonVisualAidResults"
    [isEmbeddedInQuizResult]="true"
    [embeddedStepsToReview]="stepsToReview"
    (avatarThumbnailReady)="avatarThumbnailReady.emit($event)"
  ></app-results-visual-aid>
  <ng-template #nonVisualAidResults>
    <app-results-guided
      [isEmbeddedInQuizResult]="true"
      [embeddedStepsToReview]="stepsToReview"
      (avatarThumbnailReady)="avatarThumbnailReady.emit($event)"
    ></app-results-guided>
  </ng-template>
</ng-container>
